import { BaseService } from "./base.service";

export abstract class BaseController extends BaseService {

}



// WEBPACK FOOTER //
// ./src/core/controllers/base.controller.ts